module.exports = "<div class=\"info-box tariffs-block\" *ngIf=\"curentTariff\">\n  <div class=\"tariffs-block__name\">\n    {{curentTariff.tariff}}\n    <br>\n    <span *ngIf=\"!currentDevice.isHiddenPhone\">+{{curentTariff.number}}</span>\n  </div>\n  <div class=\"tariffs-block__date\">Оплачен до {{curentTariff.dateFormat}}</div>\n  <div class=\"tariffs-block__btn btn\"  (click)=\"openTariffModal(curentTariff)\">Продлить</div>\n</div>\n<tariff-modal #tariffModal></tariff-modal>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/view/components/tariffs-block/tariffs-block.component.html
// module id = ./src/app/view/components/tariffs-block/tariffs-block.component.html
// module chunks = main